<script setup>
import { ref, computed } from "vue"

const props = defineProps({
  units: {
    //type: String or Array,
    default: "1,1,1,1,1,1,1,1,1,1"
  },
  labels: {
    type: Boolean,
    default: true,
  },
  editable: {
    type: Boolean,
    default: false,
  },
  unitGap: {
    type: Number,
    default: 4,
  },
  unitSize: {
    type: Number,
    default: 28,
  },
  rounded: {
    type: String,
    default: "md",
  }
});

const emit = defineEmits(['unitSelect', 'unitUnselect', 'unitChange']);

let uw = props.unitSize || 28;
let uh = props.unitSize || 28;
let ugap = props.unitGap || 4;

let list = [];
let index = 0;
let tlen = 0;

if (props.units && typeof props.units == "string") {
  let parts = props.units.split(/,/g);
  for (let p of parts) {
    let len = parseInt(p.replace(/[^\d]+/g, ""));
    let status = "full";
    if (p.includes("?")) {
      status = "empty";
    }
    if (p.includes("x")) {
      status = "unselect";
    }
    list.push({
      index: ++index,
      units: len,
      status: status,
      width: len * uw + (len-1) * ugap,
      height: uh,
    });
    tlen += len;
  }
  if (tlen < 10) {
    let len = 10 - tlen;
    list.push({
      index: ++index,
      units: len,
      status: "undefined",
      width: len * uw + (len-1) * ugap,
      height: uh,
    });
  }
}
else if (props.units instanceof Array) {
  list = props.units;
}

const inserts = ref(list);
</script>

<template>
  <!-- <div class="w-full">
    <div class="flex items-stretch">
      <div class="text-black bg-amber-500 grid place-items-center" style="width: 112px; height: 36px; margin-right: 2px;">3</div>
      <div class="text-black bg-amber-500 grid place-items-center" style="width: 190px; height: 36px; margin-right: 2px;">5</div>
      <div class="text-black bg-amber-500 grid place-items-center" style="width: 74px; height: 36px; margin-right: 2px;">2</div>
    </div>
    <div class="flex items-stretch mt-1 mb-1">
      <div class="text-black ring-4" style="width: 36px; height: 36px; margin-right: 2px;" v-for="i in 10"></div>
    </div>
    <div class="flex items-stretch">
      <div class="text-black bg-amber-500 grid place-items-center" style="width: 36px; height: 36px; margin-right: 2px;">1</div>
      <div class="text-black bg-amber-500 grid place-items-center" style="width: 36px; height: 36px; margin-right: 2px;">1</div>
      <div class="text-black bg-amber-500 grid place-items-center" style="width: 36px; height: 36px; margin-right: 2px;">1</div>
      <div class="text-black bg-amber-500 grid place-items-center" style="width: 112px; height: 36px; margin-right: 2px;">3</div>
      <div class="text-black bg-amber-500 grid place-items-center" style="width: 74px; height: 36px; margin-right: 2px;">2</div>
      <div class="text-black bg-amber-500 grid place-items-center" style="width: 74px; height: 36px; margin-right: 2px;">2</div>
    </div>
  </div> -->
  <div class="w-full">
    <div class="flex flex-row mt-1 mb-1">
      <div class="aspect-square grid place-items-center" :class="'status-' + insert.status + ' ' + 'rounded-' + props.rounded" :style="{ 'width': insert.width + 'px', 'height': insert.height + 'px', 'margin-left': (index > 0 ? props.unitGap + 'px' : '') }" v-for="(insert, index) in inserts"><span v-if="props.labels">{{ insert.units }}</span></div>
    </div>
  </div>
</template>

<style scoped>
.status-full {
  @apply text-white bg-blue-700;
}

.status-empty, .status-undefined {
  @apply text-black bg-gray-200;
}

.status-unselect {
  @apply text-black bg-blue-200;
}
</style>